"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.RadioButton = void 0;
/*
 * © 2024 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
const React = __importStar(require("react"));
const styled_components_1 = require("../styled-components");
const Wrapper = styled_components_1.styled.div `
  position: relative;
  margin: 0;
  height: 20px;
  width: 20px;
  border-radius: 50%;
  background: ${(props) => props.theme.bg};
  box-shadow: inset 0 1px 1px #000d;
  display: flex;
  align-items: center;
  justify-content: center;
`;
const Input = styled_components_1.styled.input `
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
  width: 60%;
  height: 60%;
  margin: 0;
  :checked {
    transform: scale(0.9);
    filter: saturate(0);
  }
  :not(:checked) {
    opacity: 0;
  }
`;
const RadioButton = ({ id, onChange, title, name, disabled, checked, value, }) => {
    return (React.createElement(Wrapper, { title: title },
        React.createElement(Input, { type: "radio", id: id, onChange: onChange, "aria-label": `${name} : ${value}`, name: name, disabled: disabled, checked: checked })));
};
exports.RadioButton = RadioButton;
//# sourceMappingURL=RadioButton.js.map